export default __webpack_public_path__ + "static/media/update_logo.aed2c0b6.svg";